import type { DirectMessageChannel, Friendship } from '@/types'
import type { Message } from '@/types'

export const dmChannels: DirectMessageChannel[] = [
  {
    id: 'dm1',
    participantIds: ['u1', 'u2'],
    lastMessagePreview: 'Hey, did you see the new spatial audio update?',
    lastMessageAt: Date.now() - 300000,
    unreadCount: 2,
  },
  {
    id: 'dm2',
    participantIds: ['u1', 'u4'],
    lastMessagePreview: 'The E2E encryption module is looking great.',
    lastMessageAt: Date.now() - 3600000,
    unreadCount: 0,
  },
  {
    id: 'dm3',
    participantIds: ['u1', 'u7'],
    lastMessagePreview: 'Want to join the voice chat later?',
    lastMessageAt: Date.now() - 86400000,
    unreadCount: 1,
  },
]

export const dmMessages: Record<string, Message[]> = {
  'dm1': [
    { id: 'dm1-m1', channelId: 'dm1', authorId: 'u2', content: 'Hey Nova! Got a minute?', timestamp: Date.now() - 600000 },
    { id: 'dm1-m2', channelId: 'dm1', authorId: 'u1', content: 'Sure, what\'s up?', timestamp: Date.now() - 550000 },
    { id: 'dm1-m3', channelId: 'dm1', authorId: 'u2', content: 'Have you tried the new spatial audio positioning? It\'s really immersive in the lounge.', timestamp: Date.now() - 500000 },
    { id: 'dm1-m4', channelId: 'dm1', authorId: 'u1', content: 'Not yet! I\'ll hop in after I finish this PR.', timestamp: Date.now() - 450000 },
    { id: 'dm1-m5', channelId: 'dm1', authorId: 'u2', content: 'Hey, did you see the new spatial audio update?', timestamp: Date.now() - 300000 },
  ],
  'dm2': [
    { id: 'dm2-m1', channelId: 'dm2', authorId: 'u4', content: 'Pushed the E2E module to the repo.', timestamp: Date.now() - 7200000 },
    { id: 'dm2-m2', channelId: 'dm2', authorId: 'u1', content: 'Awesome, I\'ll review it today.', timestamp: Date.now() - 7000000 },
    { id: 'dm2-m3', channelId: 'dm2', authorId: 'u4', content: 'The E2E encryption module is looking great.', timestamp: Date.now() - 3600000 },
  ],
  'dm3': [
    { id: 'dm3-m1', channelId: 'dm3', authorId: 'u7', content: 'Hey, the gaming channel is active tonight', timestamp: Date.now() - 90000000 },
    { id: 'dm3-m2', channelId: 'dm3', authorId: 'u1', content: 'Cool! I\'ll try to join.', timestamp: Date.now() - 89000000 },
    { id: 'dm3-m3', channelId: 'dm3', authorId: 'u7', content: 'Want to join the voice chat later?', timestamp: Date.now() - 86400000 },
  ],
}

export const friendships: Friendship[] = [
  { id: 'f1', userId: 'u1', targetId: 'u2', status: 'accepted', createdAt: Date.now() - 86400000 * 30 },
  { id: 'f2', userId: 'u1', targetId: 'u4', status: 'accepted', createdAt: Date.now() - 86400000 * 14 },
  { id: 'f3', userId: 'u1', targetId: 'u7', status: 'accepted', createdAt: Date.now() - 86400000 * 7 },
  { id: 'f4', userId: 'u3', targetId: 'u1', status: 'pending_incoming', createdAt: Date.now() - 86400000 },
  { id: 'f5', userId: 'u1', targetId: 'u8', status: 'pending_outgoing', createdAt: Date.now() - 86400000 * 2 },
  { id: 'f6', userId: 'u1', targetId: 'u5', status: 'blocked', createdAt: Date.now() - 86400000 * 60 },
]
